import {
  NodetemplatesV1NodeTemplate,
  NodetemplatesV1TaintWithOptionalEffect,
  CastaiAutoscalerV1beta1AWSNodeTemplateMigrationIntent,
  CastaiAutoscalerV1beta1ProvisionerMigrationIntent,
} from '@cast/openapi';

export type {
  PoliciesV1Policies as PoliciesConfig,
  PoliciesV1SpotInstances as SpotInstances,
  PoliciesV1NodeDownscaler as NodeDownscaler,
  PoliciesV1ClusterLimitsPolicy as ClusterLimitsPolicy,
  PoliciesV1UnschedulablePodsPolicy as UnschedulablePodsPolicy,
  PoliciesV1GetClusterNodeConstraintsResponse as NodeConstraintResponse,
  NodetemplatesV1UpdateNodeTemplate as UpdateSelectionTemplate,
  NodetemplatesV1NewNodeTemplate as CreateSelectionTemplate,
  NodetemplatesV1FilterInstanceTypesResponse as UpdateSelectionTemplateResponse,
  NodetemplatesV1AvailableInstanceType as SelectedInstanceType,
  NodetemplatesV1NodeTemplate as NodeSelectionTemplate,
  NodetemplatesV1EdgeLocationConfig as NodeTemplateEdgeLocationConfig,
  NodetemplatesV1NodeTemplateListItem as NodeSelectionTemplateSummary,
  CastaiAutoscalerV1beta1GetClusterSettingsResponse as AutoscalerFeatures,
  CastaiAutoscalerV1beta1CAPatchInfo as AutoscalerCAPatchInfo,
  NodetemplatesV1ListNodeTemplatesResponse as NodeSelectionListResponse,
  CastaiEvictorV1AdvancedConfig as AdvancedEvictorConfigResponse,
  CastaiEvictorV1EvictionConfig as EvictionConfig,
  EvictorAPIApiEvictorAPIUpsertAdvancedConfigRequest as AdvancedEvictorConfigRequest,
  CastaiAutoscalerV1beta1GetKarpenterMigrationIntentResponse as KarpenterMigrationIntents,
  CastaiAutoscalerV1beta1MigrateKarpenterDefinitionsResponse as KarpenterMigrationResponse,
  NodeconfigV1ListConfigurationsResponse as NodeConfigurationsResponse,
  CastaiAutoscalerV1beta1AWSNodeTemplateMigrationResult as AWSNodeTemplateMigrationResult,
  CastaiAutoscalerV1beta1EC2NodeClassMigrationResult as EC2NodeClassMigrationResult,
  CastaiAutoscalerV1beta1NodePoolMigrationResult as NodePoolMigrationResult,
  CastaiAutoscalerV1beta1ProvisionerMigrationResult as ProvisionerMigrationResult,
  CastaiAutoscalerV1beta1AWSNodeTemplateMigrationIntent as AWSNodeTemplateMigrationIntent,
  CastaiAutoscalerV1beta1EC2NodeClassMigrationIntent as EC2NodeClassMigrationIntent,
  CastaiAutoscalerV1beta1NodePoolMigrationIntent as NodePoolMigrationIntent,
  CastaiAutoscalerV1beta1ProvisionerMigrationIntent as ProvisionerMigrationIntent,
  NodetemplatesV1TemplateConstraints as NodeTemplateConstraints,
  NodetemplatesV1TemplateConstraintsCustomPriority as NodeTemplateCustomPriority,
  NodetemplatesV1SharedGPU as SharedGpuPerTypeConfig,
  NodeTemplatesAPIApiNodeTemplatesAPIUpdateNodeTemplateRequest as UpdateNodeTemplateRequest,
  NodeTemplatesAPIApiNodeTemplatesAPICreateNodeTemplateRequest as CreateNodeTemplateRequest,
  NodetemplatesV1Taint as NodeTemplateTaint,
  NodetemplatesV1PriceAdjustmentConfiguration as NodeTemplatePriceAdjustmentConfiguration,
  NodetemplatesV1TemplateConstraintsAWSConstraintsCapacityReservation as AwsConstraintsCapacityReservation,
} from '@cast/openapi';
export {
  NodeconfigV1AKSConfigOsDiskType as OSDiskTypeEnum,
  NodeconfigV1AKSConfigOsDiskEphemeralPlacement as AksOsDiskEphemeralPlacementEnum,
  NodetemplatesV1TaintEffect as SelectionTemplateTaintEffect,
  NodetemplatesV1AvailableInstanceTypeStorageOptimizedOption as StorageOptimizedOptionEnum,
  NodetemplatesV1TemplateConstraintsConstraintState as NodeTemplateConstraintStateEnum,
} from '@cast/openapi';

export enum SpotInterruptionPredictionModelType {
  AWS_MODEL = 'aws-rebalance-recommendations',
  CASTAI_MODEL = 'interruption-predictions',
}

// TODO: remove once NodetemplatesV1NodeTemplate returns taint effect as enum value
export type NodeSelectionTemplateWithOptionalTaints = Omit<
  NodetemplatesV1NodeTemplate,
  'customTaints'
> & {
  customTaints?: NodetemplatesV1TaintWithOptionalEffect[];
};

export type KarpenterMigrationObjects = {
  templates: CastaiAutoscalerV1beta1ProvisionerMigrationIntent[];
  configurations: CastaiAutoscalerV1beta1AWSNodeTemplateMigrationIntent[];
};

export type NodeSelectionTemplateWithClusterId = NodetemplatesV1NodeTemplate & {
  clusterId: string;
};
